import { documentFormMixin } from './documentForm';

// @vuese
// OW-003-Prezydencki Mixin
export const ow003PrezydenckiMixin = {
  mixins: [documentFormMixin],
  computed: {
    behaviorGrades() {
      return this.dictionary.behaviorGrades;
    },
    gradeLevels() {
      const gradeLevels = [
        { value: 'I', text: 'I' },
        { value: 'II', text: 'II' },
        { value: 'III', text: 'III' },
        { value: 'IV', text: 'IV' },
        { value: 'V', text: 'V' },
        { value: 'VI', text: 'VI' },
        { value: 'VII', text: 'VII' },
        { value: 'VIII', text: 'VIII' }
      ];
      if (this.schema.$model.data.school && this.schema.$model.data.school.level === 1) {
        return gradeLevels.slice(3);
      } else if (this.schema.$model.data.school && this.schema.$model.data.school.level === 2) {
        return gradeLevels.slice(0, 5);
      }
      return gradeLevels;
    },
    contestTypes() {
      return this.dictionary.contestTypes;
    },
    schoolLevels() {
      return this.dictionary.schoolLevels;
    },
    genders() {
      return this.dictionary.genders;
    },
    studentGenders() {
      return this.dictionary.studentGenders;
    },
    typesOfPayment() {
      return this.dictionary.paymentTypes;
    }
  },
  methods: {
    // @vuese
    // Czy konkurs jest pobrany ze słownika
    contestFilter(contestName) {
      return this.contestTypes.some(x => {
        return x === contestName;
      });
    }
  }
};
